import {types} from 'mobx-state-tree';
import EquipmentModel from '../models/equipment-model';

const models = [
	'306A',
	'84 VT',
	'86 VT',
	'A1 M2M',
	'A1 Max',
	'A1 Trax',
	'A11',
	'A306',
	'A5 GLX',
	'A9 GPS tracker',
	'A9',
	'ACP',
	'ADM007',
	'ADM100',
	'ADM101',
	'ADM300',
	'ADM333',
	'ADM700 3G',
	'ADM700',
	'ADM703 3G',
	'ADM710',
	'AE1-W',
	'AE1',
	'AIS140',
	'AIVDM/AIVDO AIS',
	'AL-900E',
	'AL900',
	'AM1-S',
	'AM1-S(V)',
	'AM1-W',
	'AM1-W(V)',
	'AM3-S',
	'AM3-S(V)',
	'AM3-W',
	'AM3-W(V)',
	'Amparos S4',
	'AMT GPS Tracker',
	'AnioSmart A510',
	'Aplicom C-series',
	'Aplicom Q-series',
	'Appello 4P',
	'Aquila Track Series',
	'AR-2CX',
	'AR-2GM',
	'AR-3HU',
	'Ardi 01',
	'Arknav CT-X8',
	'Arknav GX',
	'Arknav RX',
	'ARNAVI',
	'Aspicore',
	'Astra Telematics AT Series',
	'Astro 120',
	'AT-04',
	'AT-1',
	'AT-12A',
	'AT-18',
	'AT-200',
	'AT-210',
	'AT-240',
	'AT-5000',
	'AT-9000',
	'AT03',
	'AT06',
	'AT06+',
	'AT07',
	'AT09',
	'AT2000',
	'AT35 3G',
	'AT35 4G/LTE MiFi',
	'AT35 LTE',
	'AT35',
	'AT4 2G',
	'AT6 3G',
	'ATrack AK1',
	'ATrack AK11',
	'ATrack AK7S',
	'ATrack AK7V',
	'ATrack AL1',
	'ATrack AL11',
	'ATrack AL7',
	'ATrack AP1',
	'ATrack AS1',
	'ATrack AS11',
	'ATrack AS3',
	'ATrack AT1',
	'ATrack AT1Pro',
	'ATrack AT3',
	'ATrack AT5',
	'ATrack AT5i',
	'ATrack AU5',
	'ATrack AU5i',
	'ATrack AU7',
	'ATrack AX11',
	'ATrack AX5',
	'ATrack AX5C',
	'ATrack AX7',
	'ATrack AX7P',
	'ATrack AX9',
	'ATrack AY5',
	'ATrack AY5i',
	'ATRAX-S1',
	'ATU-620',
	'AURO Comfort 1060',
	'AUTOCOP',
	'AutoFon D',
	'AutoFon SE',
	'AutoFon SE+',
	'AutoGrade',
	'AutoTrack XL',
	'AutoTrack еLite',
	'AVL-011',
	'AVL-900',
	'AVL-900(M)',
	'AVL-900(R)',
	'AVL-901(B)',
	'AVL-901(C)',
	'AVL-901(D)',
	'AVL-921',
	'Base Block Iridium',
	'Base Block Lite',
	'Base Block Optimum',
	'Base Block Wi-Fi Hub',
	'Base Block Wi-Fi',
	'Base Block',
	'BAT-M1',
	'BAT-X',
	'BCE FM Blue',
	'BCE FM Blue+',
	'BCE FM Light',
	'BCE FM Light+',
	'BCE FM-500 Blue',
	'BCE FM-500 Blue+',
	'BCE FM-500 Light',
	'BCE FM-500 Light+',
	'BCE FM-500 Tacho',
	'BCE FMS500 Light',
	'BCE FMS500 Light+',
	'BCE FMS500 One',
	'BCE FMS500 STCAN',
	'BCE FMS500 Tacho',
	'BD-2012',
	'BD-3112',
	'Benway ET300',
	'Bitrek Series',
	'BK-FLT-P1',
	'BlackKite Fleet',
	'Bofan PT03',
	'Bofan PT100',
	'Bofan PT200',
	'Bofan PT201',
	'Bofan PT30',
	'Bofan PT300X',
	'Bofan PT500',
	'Bofan PT502',
	'Bofan PT510',
	'Bofan PT520',
	'Bofan PT60',
	'Bofan PT600',
	'Bofan PT600X',
	'Bofan PT80',
	'BOX iSpot',
	'BOXoptions+',
	'BOXsolo',
	'BOXtracker',
	'BSTPL-15',
	'BSTPL-17',
	'BSTPL-17A',
	'BSTPL-17IS',
	'BW02',
	'BW08',
	'BW09',
	'BWS E3+',
	'C-100',
	'C2STEK',
	'C32',
	'CalAmp',
	'Cantrack G01',
	'Cantrack G02',
	'Cantrack G03',
	'Cantrack G05',
	'Cantrack T80 OBD',
	'Carcell CR1000',
	'Carcell CR2000',
	'Carcell CR250',
	'Carcell CR3000',
	'Carcell CR4000',
	'Careu Ueco',
	'Castel',
	'Cautela',
	'CC830',
	'CCRT809',
	'CCTR 830-4G',
	'CCTR-620',
	'CCTR-620+',
	'CCTR-622',
	'CCTR-622G',
	'CCTR-630',
	'CCTR-700',
	'CCTR-800',
	'CCTR-800G',
	'CCTR-801',
	'CCTR-802',
	'CCTR-803',
	'CCTR-808',
	'CCTR-810',
	'CCTR-830G',
	'CCTR',
	'CelloTrack 6M (IP65)',
	'CelloTrack IP67',
	'CelloTrack XT',
	'cGuard Atom',
	'cGuard Beacon',
	'cGuard Litom',
	'cGuard OBD',
	'cGuard Personal',
	'CH-4713',
	'CH-5703',
	'Chentian OBD',
	'Cityeasy 006',
	'Cityeasy 007',
	'Cityeasy 008',
	'Cityeasy 009',
	'Cityeasy 100',
	'Cityeasy 200',
	'Cityeasy 201',
	'Cityeasy 202',
	'Cityeasy 302',
	'Cityeasy 306',
	'Cityeasy 520',
	'Coban 303F',
	'Coban GPS106',
	'Coban GPS107',
	'Coban GPS301',
	'Coban GPS302',
	'Coban GPS303',
	'Coban GPS304',
	'Coban GPS305',
	'Coban GPS306',
	'Coban',
	'Concox At4',
	'Concox CRX1 New',
	'Concox CRX1',
	'Concox CRX3',
	'Concox GK301',
	'Concox GK503',
	'Concox GT02D',
	'Concox GT03',
	'Concox GT03A',
	'Concox GT03B',
	'Concox GT07',
	'Concox GT300',
	'Concox GT710',
	'Concox GT800',
	'Concox OB22',
	'Concox Qbit',
	'Continental Compact',
	'Continental Evolution',
	'Continental Vehicle Tracker',
	'Continental ZGO',
	'Continental',
	'CR2000/3000',
	'CR4000',
	'CradlePoint IBR1100',
	'CradlePoint IBR600',
	'CradlePoint IBR900',
	'CradlePoint IBR950',
	'Cradlepoint S700',
	'CradlePoint',
	'CRX1 NEW',
	'CRX1',
	'CRX3 MINI',
	'CRX3 NEW',
	'CRX3',
	'CRX7 3G',
	'CT-24',
	'CT-58',
	'CT-58A',
	'CT-X8',
	'CT01',
	'CT03',
	'CT04-R',
	'CT04-X',
	'CT04',
	'CT2000E',
	'Custodium',
	'D-WAY',
	'D11',
	'Damoov Telematics SDK',
	'DART',
	'Datamax',
	'DDX04',
	'DDX14',
	'DDX15',
	'DF550',
	'DF702',
	'Disha 9310',
	'Disha 9320',
	'Disha 9330',
	'Dolphin DO107',
	'DSF10',
	'DSF21',
	'DSF22',
	'DT-700',
	'DX-3',
	'E-Track',
	'E3 Plus',
	'E3',
	'E3+',
	'E3+4G',
	'E4 MINI',
	'E4',
	'Ebike Tracker',
	'EC-546',
	'EGTS (Era-Glonass)',
	'Ekas Tracker',
	'Enfora GSM2338',
	'Enfora GSM2448',
	'Enfora MT4000',
	'EQT-20',
	'ES610',
	'ES821',
	'ES825',
	'eSeal',
	'Eskort TD-Online',
	'ET-01',
	'ET-06',
	'ET-700',
	'ET-700C',
	'ET100',
	'ET301',
	'ET800E',
	'EV-07',
	'EV-07P',
	'EV-07S',
	'EV-07W',
	'EV-601',
	'EV-602',
	'EV-603',
	'EV-606',
	'EV02',
	'F1',
	'FCM650',
	'Fifotrack A100',
	'Fifotrack A200',
	'Fifotrack A300',
	'Fifotrack A500',
	'Fifotrack A600',
	'Fifotrack A700',
	'Fifotrack Q1',
	'Fifotrack Q2',
	'Fifotrack S20',
	'Fifotrack S30',
	'Fifotrack S50',
	'Fifotrack S60',
	'Fifotrack S70',
	'FleetGuide',
	'Flespi',
	'Flexcomm Series',
	'FM 500Q',
	'FM-ECO 4',
	'FM-Eco3',
	'FM-Pro3-R',
	'FM-Pro3',
	'FM-Tco3',
	'FM02',
	'FM03E',
	'FM1010',
	'FM1100',
	'FM1110',
	'FM1120',
	'FM1202',
	'FM1204',
	'FM2100',
	'FM2200',
	'FM3001',
	'FM3200',
	'FM3300',
	'FM3612',
	'FM3622',
	'FM36M1',
	'FM4100',
	'FM4200',
	'FM5300',
	'FM6300',
	'FM6320',
	'FMA110',
	'FMA120',
	'FMA202',
	'FMA204',
	'FMB001',
	'FMB002',
	'FMB003',
	'FMB010',
	'FMB020',
	'FMB110',
	'FMB120',
	'FMB122',
	'FMB125',
	'FMB130',
	'FMB140',
	'FMB150',
	'FMB202',
	'FMB204',
	'FMB208',
	'FMB630',
	'FMB640',
	'FMB900',
	'FMB920',
	'FMB962',
	'FMB964',
	'FMB965',
	'FMC001',
	'FMC003',
	'FMC125',
	'FMC130',
	'FMC150',
	'FMC640',
	'FMC920',
	'FMM001',
	'FMM003',
	'FMM125',
	'FMM130',
	'FMM150',
	'FMM640',
	'FMM920',
	'FMS500 StScan',
	'FMS500 Tacho',
	'FMS500',
	'FMT100',
	'FMU125',
	'FMU126',
	'FMU130',
	'Fox Advanced AVL',
	'Fox Easy AVL',
	'Fox Lite AVL',
	'Freedom PT-10',
	'Freedom PT-9',
	'Freematics ONE',
	'FT-3150',
	'Futureway',
	'G-100',
	'G-300',
	'G-310N',
	'G-310P',
	'G-316',
	'G-360N',
	'G-360P',
	'G-420 Padlock',
	'G-508N',
	'G-666',
	'G-T005',
	'G-TL-020',
	'G02',
	'G05',
	'G06L',
	'G08L',
	'G09L',
	'G100',
	'G109',
	'G17O',
	'G18',
	'G19',
	'G19H',
	'G19S',
	'G1C',
	'G30',
	'G500M',
	'G52S',
	'G60',
	'G900',
	'G9001N',
	'G900L',
	'G91S',
	'Galeb GS100',
	'GalileoSky 2.5',
	'GalileoSky 4.0',
	'GalileoSky 5.0',
	'GalileoSky 5.1',
	'GalileoSky 7.0 Lite',
	'GalileoSky 7.0',
	'GalileoSky Boxfinder',
	'Galileosky OBD-II',
	'GB100',
	'GB100MG',
	'GB101',
	'GC-101',
	'Gelix-2',
	'Gelix',
	'Generico',
	'GEO1',
	'GEO5',
	'Getrak GTK110',
	'Getrak NR01',
	'GetrakFox',
	'GF200LS',
	'GF40',
	'GF60L',
	'GF70L',
	'GH-5200',
	'GH3000',
	'GL100',
	'GL100M',
	'GL200',
	'GL300',
	'GL3000W Series',
	'GL300N',
	'GL300VC',
	'GL300W Series',
	'GL500',
	'GL505',
	'GL520',
	'Globalstar',
	'GlobeKeeper',
	'GMT-368',
	'GMT-368SQ',
	'GMT100',
	'GMT200',
	'GMT368s',
	'GNX-10',
	'GNX-10L',
	'GNX-2',
	'GNX-20',
	'GNX-3',
	'GNX-5P',
	'GNX-6',
	'Goome GM06NW',
	'Goome',
	'GoSafe G1RUS',
	'GoSafe G1S',
	'GoSafe G2P',
	'GoSafe G3A',
	'GoSafe G3C',
	'GoSafe G3S',
	'GoSafe G3SC',
	'GoSafe G6S',
	'GoSafe G717',
	'GoSafe G737',
	'GoSafe G777',
	'GoSafe G79',
	'GoSafe G797',
	'GoSafe G797W',
	'GoSafe G91I',
	'GoSafe GS16',
	'GoSafe',
	'GOT08',
	'GOT10',
	'GP-900M',
	'GP106M',
	'GP4000',
	'GP5000',
	'GP6000',
	'GPS Marker M100',
	'GPS Marker M130',
	'GPS Marker M60',
	'GPS Marker M70',
	'GPS Marker M80',
	'GPS-103-A',
	'GPS-103',
	'GPS-911(M)',
	'GPS056',
	'GPS102',
	'GPS102B',
	'GPS103',
	'GPS104',
	'GPS105',
	'GPS105B',
	'GPS303-G',
	'GPS311A',
	'GPS668',
	'GpsGate',
	'GPSLogger',
	'GPSMTA',
	'GPSRX12',
	'GPSRX14',
	'GPSRX16',
	'GPT-69',
	'GPT06-3G',
	'GPT06',
	'GPT09',
	'GPT12-L',
	'GPT12',
	'GPT15',
	'GPT18',
	'GPT19',
	'GPT26',
	'GPT46',
	'Granit Navigator 4',
	'Granit Navigator 5',
	'Granit-Navigator',
	'Great Will TR05',
	'GRTQ',
	'Gruz',
	'GS-818',
	'GS100',
	'GS503',
	'GSM5108',
	'GSY007',
	'GT 30',
	'GT-110ES',
	'GT-110K',
	'GT-110M',
	'GT-110P',
	'GT-110ZS',
	'GT-30',
	'GT-89',
	'GT-99',
	'GT02',
	'GT02A',
	'GT06',
	'GT06D',
	'GT06N',
	'GT09',
	'GT100',
	'GT200',
	'GT230',
	'GT30',
	'GT300',
	'GT301',
	'GT30i',
	'GT30X',
	'GT3105MG-PT',
	'GT500',
	'GT60',
	'GTK LW4G',
	'GTK 110',
	'GTLT3',
	'GTR-100',
	'GTR-128',
	'GTR-129',
	'GTRACK4G',
	'Guardiancar',
	'GV200',
	'GV300',
	'GV300N',
	'GV300VC',
	'GV300W',
	'GV50',
	'GV500 OBDII',
	'GV500',
	'GV500MAP',
	'GV500VC',
	'GV50LTA',
	'GV50P',
	'GV55 Lite',
	'GV55',
	'GV55N',
	'GV55VC',
	'GV600W',
	'GV65 Plus',
	'GV65',
	'GV75',
	'GV75N',
	'GV75W',
	'GVT-369',
	'GVT-390',
	'GVT-500',
	'GVT-510',
	'GX-101',
	'H-02A',
	'H-02B',
	'H-06',
	'H02',
	'H08',
	'HB-A5',
	'HC06A',
	'HC207',
	'Heacent 908',
	'Helios Advanced',
	'Helios Hybrid',
	'Helios TT',
	'Helios',
	'HI-602',
	'HI-602X',
	'HI-603',
	'HI-603X',
	'HI-604',
	'HI-604X',
	'HI-605X',
	'Homtecs H20',
	'Hoopo Platform API',
	'HS-1200',
	'HS-2000C',
	'HS-2000G',
	'HS-3000G',
	'HS-300V',
	'HS-400',
	'HS-4000W',
	'HS-500P',
	'HS-800W',
	'HT-192',
	'HT-196R',
	'i-MXT',
	'i-Trac MT1',
	'i-Trac VT600X',
	'IB-GT102',
	'ICAR GPS IK703',
	'Icomera MoovBox',
	'IDD-212B',
	'IDD-212GL',
	'IDD-213G',
	'IDD-213GD',
	'IDD-213L',
	'IDD-213N/E',
	'IDD-213T',
	'IDD-218G',
	'IDP-780',
	'IDPL',
	'iMars Micro',
	'iMXT',
	'Incutex TK105',
	'Intellinet IVT 401',
	'IntelliTrac P1',
	'IntelliTrac X1 Plus',
	'IntelliTrac X8',
	'IR-7',
	'iStartek VT100-L',
	'iStartek VT100',
	'iStartek VT200 L',
	'iStartek VT200',
	'iStartek VT202',
	'iStartek VT206',
	'iStartek VT600',
	'iStartek VT900',
	'Iter ITR120',
	'Iter ITR150',
	'Iter ITR155',
	'iTrackPro',
	'ITS',
	'J14',
	'J16',
	'JI09',
	'JM-VG01U',
	'JM-VG02U',
	'JM-VL01',
	'JM-VL02',
	'JM-VL03',
	'JM-VL04',
	'JM01',
	'JM08',
	'JM09',
	'Jointech',
	'JP-KORJAR',
	'JT600',
	'JT700',
	'JT700A',
	'JT700B',
	'JT700C',
	'JT701',
	'JT705',
	'JV200',
	'K20',
	'K30',
	'K6',
	'K9',
	'K9+',
	'Karitec',
	'KC200',
	'Kenji KJ-8501',
	'KG100',
	'KG200',
	'KG300',
	'Kingneed TK20',
	'Kingneed',
	'Kingwo LT01',
	'Kingwo LT03',
	'Kingwo LT12',
	'Kingwo MT01',
	'Kingwo MT02S',
	'Kingwo MT03',
	'Kingwo MT06',
	'Kingwo MT07',
	'Kingwo MT08',
	'Kingwo MT09',
	'Kingwo MT100',
	'Kingwo MT13',
	'Kingwo NT01',
	'Kingwo NT06E',
	'Kingwo WT01',
	'Kingwo WT26',
	'Kingwo WT27',
	'KS168',
	'KS168M',
	'KT90',
	'L-100',
	'L300',
	'L300wi',
	'LairdTech LT100',
	'Lantrix T1700',
	'Lantrix',
	'LBT1',
	'Leaf Spy Pro',
	'LGT92',
	'Light 2.0',
	'Light',
	'LK106',
	'LK109',
	'LK110',
	'LK120',
	'LK206',
	'LK206A',
	'LK206B',
	'LK208',
	'LK209',
	'LK209C',
	'LK210',
	'LK310',
	'LK610',
	'LK660',
	'LK670',
	'LK700',
	'LK710',
	'LK800',
	'LK910',
	'LK920',
	'LK930',
	'LKGPS LK710C',
	'LMU-1100 Series',
	'LMU-1200 Series',
	'LMU-200 Series',
	'LMU-2000 Series',
	'LMU-2100 Series',
	'LMU-2600 Series',
	'LMU-2620',
	'LMU-2700 Series',
	'LMU-2720',
	'LMU-300 Series',
	'LMU-3030',
	'LMU-328',
	'LMU-400 Series',
	'LMU-4200 Series',
	'LMU-4520 Series',
	'LMU-5000 Series',
	'LMU-700 Series',
	'LMU-800 Series',
	'LMU-900 Series',
	'Locus Pro Android',
	'Lommy Eye',
	'Lommy Personal',
	'Lommy Pro',
	'LT-162',
	'LT-163L',
	'LW4G',
	'M1',
	'M2C2020',
	'M2M IP Modem F7114',
	'M2M-Mini',
	'M320',
	'M508',
	'M518',
	'M518S',
	'M528',
	'M588N',
	'M588S',
	'MA100-1010',
	'Maestro MT-01',
	'Marelli TBox',
	'MasterKit BM8009',
	'MasterKit',
	'MAVLink compatible drones',
	'MC300',
	'MDT-7',
	'MeSafe',
	'MI-G6',
	'Micro Genie',
	'MicroControl',
	'Microhard',
	'MicTrack B21',
	'Mictrack B2316',
	'Mini MT',
	'MiniFinder Atto Pro',
	'MiniFinder Atto',
	'MiniFinder Nano',
	'MiniFinder Pico',
	'MiniFinder Rex',
	'MiniFinder Xtreme One',
	'MiniFinder Xtreme',
	'MM101A',
	'Motor',
	'Motorola HF',
	'MP10',
	'MP2030A',
	'MP2030B',
	'MP2031A',
	'MP2031B',
	'MP2031C',
	'MP80',
	'MP90',
	'MPIP-618',
	'MPIP-619',
	'MPIP-620',
	'MPU-01 GLONASS',
	'MPU-01',
	'MSP500',
	'MT-1',
	'MT-100',
	'MT-101',
	'MT-20',
	'MT-60X',
	'MT-90',
	'MT-90x',
	'MT01',
	'MT02',
	'MT110',
	'MT2000',
	'MT2000',
	'MT2000S',
	'MT200x',
	'MT300',
	'MT4x00',
	'MT500',
	'MT510-G',
	'MT510',
	'MT510G',
	'MT530',
	'MT550',
	'MT60-X',
	'MT600',
	'MT700',
	'MT80',
	'MT80i',
	'MT821',
	'MT825',
	'MT88',
	'MT90',
	'MT99 4G LTE',
	'MT99',
	'MTA-02-CAM',
	'MTA-02-GLONASS',
	'MTA-02',
	'MTA-03',
	'MTA-12',
	'MTB100',
	'MTC-700',
	'MTC-780',
	'MTC400',
	'MTC500',
	'MTX-Tunnel GPS',
	'MU-201',
	'MultiConnect rCell',
	'MV720',
	'MV740',
	'MVT100',
	'MVT340',
	'MVT380',
	'MVT600',
	'MVT800',
	'MX-100',
	'MXT 160',
	'MXT-100',
	'MXT-100N',
	'MXT-101',
	'MXT-101N',
	'MXT-120',
	'MXT-130D',
	'MXT-140',
	'MXT-141',
	'MXT-142',
	'MXT-150',
	'MXT-151',
	'MXT-160',
	'MXT-162',
	'MXT-G100',
	'MXT130',
	'MXT140',
	'MXT150',
	'MXT160',
	'N4',
	'Naviset GT-20',
	'Navixy M7',
	'NEO1',
	'NEO2',
	'NEO5',
	'NEO7',
	'NeoTech TR_1000',
	'NET',
	'Niagara',
	'NIOT',
	'NR002',
	'NR006',
	'NR008',
	'NR01',
	'NR016',
	'NR024',
	'NR028',
	'NR032',
	'NT-183G',
	'NT-183W',
	'NT20',
	'NT201',
	'NT202',
	'NT40',
	'NTO tracker',
	'NVS-RTK-M',
	'O-300',
	'OBD189',
	'OBD2 V20',
	'OCT600-CAM',
	'OCT600-SG3',
	'OCT600',
	'OCT800-D',
	'OCT800',
	'OCT900-R',
	'OCT900',
	'OKO-E',
	'OKO-NAVI',
	'OKO-S2',
	'Omega T600',
	'OpenGTS',
	'Optim 2.0',
	'Optim',
	'Orbisat',
	'Orion ET-100',
	'Orion OBDtrac',
	'OsmAnd',
	'OST800',
	'OwnTracks',
	'Oyster Sigfox',
	'OYSTER',
	'P008',
	'P10',
	'P168',
	'P169',
	'P300',
	'P60LC',
	'P99G',
	'PathAway',
	'PEBBELL',
	'Peplink Transit Mini',
	'Pepwave MAX BR1',
	'Personal',
	'PG22',
	'PG88',
	'Piccolo ATX Asset​​',
	'Piccolo ATX II​​',
	'Piccolo ATX2S​​',
	'Piccolo Hybrid+​​​',
	'Piccolo Plus',
	'Piccolo STX​​',
	'Piccolo TMX+​​​',
	'Picotrack Endurance Primary',
	'Picotrack Endurance Rechargeable',
	'Picotrack IP69 K',
	'Picotrack',
	'Piligrim 6000N',
	'Piligrim Patrol',
	'Piligrim PL250',
	'Piligrim Stealth',
	'Piligrim Tracker-6000',
	'Plugin',
	'POLTE',
	'Portman',
	'Positioning Universal',
	'Positron GSM',
	'Positron RT305',
	'Positron RT325',
	'Pricol',
	'Prime AT Plus',
	'Profi 2.0',
	'Profi',
	'Progress 7s',
	'PST-AVL01',
	'PST',
	'PT-690',
	'PT-718',
	'PT01',
	'PT03',
	'PT200',
	'PT215',
	'PT30',
	'PT3000',
	'PT300X',
	'PT301',
	'PT33',
	'PT350',
	'PT40',
	'PT60',
	'Q-Bit',
	'QG-201',
	'Quanta Baby',
	'Quanta V2',
	'Quanta',
	'Queclink 500',
	'Queclink GV 50',
	'Queclink GV 55',
	'Queclink GV 75',
	'Queclink GV50',
	'Queclink GV50M',
	'Queclink GV55',
	'Queclink GV57',
	'Queclink GV75',
	'R-9PRO',
	'R-9W',
	'R12W',
	'Race Dynamics',
	'Radar Duo',
	'Radar Trio',
	'RadioSecure DID',
	'RadioSecure DTS',
	'RadioSecure IVM',
	'RadioSecure SLA 4',
	'RadioSecure SLA',
	'RadioSecure SLE',
	'RadioSecure SLG',
	'RadioSecure SLL',
	'RadioSecure SLM-i',
	'RadioSecure SLM-m',
	'RadioSecure SLM-x',
	'RadioSecure SLM',
	'RadioSecure SLS',
	'RadioSecure WHR',
	'RadioSecure WLS',
	'RadioSecure WTS',
	'RAMAC',
	'Recoda M610',
	'REMORA',
	'RF-16V',
	'RF-V03',
	'RF-V43',
	'RF-V47',
	'RF-V8S',
	'RFTRACK',
	'RGCOM',
	'Rinho C2',
	'Rinho C3',
	'Rinho C5',
	'Rinho Minitrack',
	'Rinho Smart IoT',
	'Rinho Spider IoT',
	'Rinho Spider',
	'Rinho Ultralite',
	'ROBOT-GPS',
	'ROBOT-UPS',
	'ROBOTRACK',
	'RomboGPS',
	'RST Absolut',
	'RST HIBRIDO',
	'RST LOW COST',
	'RST MINI 4G',
	'RST MINI LOW COST',
	'RST MINI',
	'RST MOVEL',
	'RST OBD2',
	'RST VERSAO TELEMETRIA',
	'RST-ABS',
	'RST-CARGA',
	'RST-DTMF',
	'RST-LCv2',
	'RST-MINI',
	'RST-VT (Sertech)',
	'RST-VT-EVO',
	'RST-VT-PLUS',
	'RST-VT',
	'RST-VTv2',
	'RT305',
	'RT325',
	'RT345',
	'RUT955',
	'RUT956',
	'RUTX09',
	'RUTX11',
	'RUTX12',
	'RUTX14',
	'RUTX50',
	'RV-8',
	'RV-M7',
	'RX-8W',
	'RX-9',
	'S101',
	'S101+',
	'S112U',
	'S168',
	'S20',
	'S208',
	'S22',
	'S228',
	'S300',
	'S31',
	'S88',
	'S911 Bracelet Locator HC',
	'S911 Bracelet Locator ST',
	'S911 Bracelet Locator',
	'S911 Lola',
	'S911 Personal Locator',
	'SANUL',
	'SaR-mini',
	'SAT-802',
	'SAT-LITE 3',
	'SAT-LITE 4',
	'SBC3',
	'Secumore G05',
	'Seeworld',
	'SendLocation',
	'Sierra',
	'Sigaba OutSafe',
	'Sigfox',
	'Signal S-2115',
	'Signal S-2117',
	'Signal S-2651',
	'Signal S-2652',
	'Signal S-2653',
	'Signal S-2654',
	'Signal S-4651',
	'Sinotrack ST-901',
	'SIWI',
	'SKY IoT',
	'SkyPatrol',
	'SL22',
	'SL24',
	'SL28',
	'SL42',
	'SL44',
	'SL48',
	'SLS-00886',
	'SLS-012SF',
	'Smart Crutches',
	'Smart One C',
	'Smart S-2333A',
	'Smart S-2410',
	'Smart S-2411',
	'Smart S-2412',
	'Smart S-2413',
	'Smart S-2420',
	'Smart S-2421',
	'Smart S-2422',
	'Smart S-2423',
	'Smart S-2425',
	'Smart S-2433',
	'Smart S-2435',
	'Smartcar',
	'SmartSole',
	'SMini',
	'Snapper GN8',
	'Solar Powered',
	'SPOT GEN3',
	'SPOT',
	'SpotTrace',
	'SR411 Mini',
	'SR411',
	'ST-901 A+',
	'ST-902W',
	'ST-910',
	'ST-940',
	'ST200',
	'ST210',
	'ST215',
	'ST215E',
	'ST215I',
	'ST230',
	'ST240',
	'ST300HD',
	'ST310U',
	'ST340',
	'ST340RB',
	'ST340UR',
	'ST380',
	'ST390',
	'ST4000',
	'ST410',
	'ST4305',
	'ST4315',
	'ST4945',
	'ST500',
	'ST7200',
	'ST8300',
	'ST8310',
	'ST8395',
	'ST900',
	'ST910',
	'ST940',
	'StarFinder AIRE',
	'StarFinder Bus',
	'StarFinder Lite',
	'StarLine M10',
	'StarLine M11',
	'StarLine M16',
	'StarLine M17',
	'StarLink Asset',
	'StarLink eBike',
	'StarLink eConnect',
	'StarLink RoadBuddy',
	'StarLink SVR',
	'StarLink ToGo',
	'StarLink Tracker',
	'Starlink TrackerBT',
	'StarLink TrackerCAN',
	'StarLink TrackerSF',
	'StarLink Trailer',
	'StarLink Voice',
	'Stay Safe',
	'STB IND 01',
	'STB IND 02',
	'STG T10',
	'STG T100',
	'STGT100',
	'Sting',
	'STL060',
	'Suntech (linha 200)',
	'Suntech (linha 300)',
	'Suntech (linha 900)',
	'Suntech ST200M',
	'Suntech ST340U',
	'Supermate D-series',
	'SVATech',
	'SVias',
	'SWIFTECH',
	'Syrus GPS',
	'Syrus SY2210',
	'Szorchid OC-01',
	'Szorchid OC-05',
	'Szorchid OC-06',
	'Szorchid OC-07',
	'Szorchid OC-09',
	'Szorchid OC-10',
	'Szorchid OC-11',
	'Szorchid OC-13',
	'T-104 GLONASS',
	'T-104',
	'T-104PRO',
	'T1',
	'T1024',
	'T1080',
	'T12',
	'T15400',
	'T16',
	'T18',
	'T18H',
	'T200',
	'T2024',
	'T2124',
	'T23',
	'T3',
	'T301',
	'T303',
	'T322',
	'T360-101A',
	'T360-101E',
	'T360-101P',
	'T360-103',
	'T360-106',
	'T360-108',
	'T360-269',
	'T360-269B',
	'T360-269JT',
	'T360',
	'T361',
	'T363A',
	'T363B',
	'T366',
	'T370',
	'T371',
	'T373A',
	'T373B',
	'T376',
	'T4400',
	'T57',
	'T622',
	'T622G-F9',
	'T63',
	'T800X',
	'T8603',
	'T8800',
	'T8801',
	'T8803 PRO',
	'T8803',
	'T8805',
	'T8806',
	'T8808',
	'T880X',
	'T8901',
	'T8S',
	'TA09',
	'TAT100',
	'TAT140',
	'TC55',
	'TC56',
	'TC68',
	'TC68S',
	'TC80',
	'TC85',
	'TC85D',
	'TD 300',
	'TD-50',
	'TD-60',
	'TD230',
	'TE-207',
	'TE200',
	'Techto Cruz',
	'TEK-586',
	'TEK-733',
	'Telemax',
	'Telic SBC-AVL',
	'Telic SBC3',
	'Teltonika DualCam',
	'Teltonika FMB001',
	'Teltonika FMB920',
	'Teltonika MTB100',
	'TFB-303',
	'Thuraya T2M-Dual',
	'Thuraya T2M-SAT',
	'Thuraya T2M',
	'TK STAR STICK',
	'TK-102B',
	'TK-905',
	'TK05',
	'TK06A',
	'TK10',
	'TK100',
	'TK101',
	'TK102 Clone',
	'TK102-2',
	'TK102',
	'TK102B',
	'TK103-2',
	'TK103-2B',
	'TK103',
	'TK103A 3G',
	'TK103A',
	'TK103B 3G',
	'TK103B',
	'TK104',
	'TK105A',
	'TK105B',
	'TK106',
	'TK108',
	'TK110',
	'TK115',
	'TK116',
	'TK118',
	'TK119-3G',
	'TK119-T',
	'TK119',
	'TK121',
	'TK15',
	'TK201-2',
	'TK201',
	'TK202',
	'TK203',
	'TK206',
	'TK207',
	'TK228',
	'TK303B',
	'TK303F 3G',
	'TK303G 3G',
	'TK303G',
	'TK303H',
	'TK303I',
	'TK306',
	'TK311A',
	'TK311B',
	'TK311C',
	'TK319-H',
	'TK319-L',
	'TK319',
	'TK403A 4G LTE',
	'TK403B 4G LTE',
	'TK419-4G',
	'TK419',
	'TK5000',
	'TK5000XL',
	'TK905',
	'TK909',
	'TK915',
	'TKStar TK935',
	'TL-904D',
	'TL007',
	'TL1000',
	'TL201',
	'TL206',
	'TL218',
	'TL3000',
	'TL500',
	'TL903',
	'TL904A',
	'TL904B',
	'TL904C',
	'TLP1-LM',
	'TLP2-SFB',
	'TLT-1B',
	'TLT-1C',
	'TLT-1D',
	'TLT-1F',
	'TLT-2F',
	'TLT-2H',
	'TLT-2K',
	'TLT-2N',
	'TLT-3A',
	'TLT-6C',
	'TLT-7B',
	'TLT-8A',
	'TLT-8B',
	'TLV',
	'TLW1-10A',
	'TLW2-12B',
	'TLW2-12BL',
	'TLW2-6BL',
	'TMG188',
	'TMT250',
	'TopFlyTec',
	'Toplovo',
	'Topten GT08',
	'Topten GT08S',
	'Topten GT48',
	'Topten LT02',
	'Topten LT03',
	'Topten MT05',
	'Topten MT05S',
	'Topten MT35',
	'Topten PG99',
	'Topten PT99',
	'Topten TK208',
	'Topten TK208S',
	'Topten TK218',
	'Topten TK228',
	'Topten TK428',
	'Topten TK510',
	'TopTen',
	'TP-20',
	'TP06A',
	'TR-151',
	'TR-151SP',
	'TR-20',
	'TR-203',
	'TR-206',
	'TR-600',
	'TR-600G',
	'TR-606B',
	'TR-900',
	'TR02',
	'TR06',
	'Traccar Client',
	'Trackbox',
	'Tracker for Traccar',
	'TrackerD-LS',
	'TrackerD',
	'TrackMiGaddi',
	'Trailer Tracker',
	'TrakMate',
	'TranSync AIS 140',
	'TRB245',
	'TRB255',
	'TT0024',
	'TT18 4G',
	'TT8750',
	'TT8750+',
	'TT8850',
	'TT9200',
	'TT9500',
	'TTU-1200 Series',
	'TTU-2820 Series',
	'TTU-700 Series',
	'TW-MD1101',
	'TW02B',
	'TW560',
	'TX-2',
	'TYN_886',
	'Tytan SAT DS520',
	'Tytan SAT DS530',
	'Tytan SAT DS540',
	'TZ-AVL02',
	'TZ-AVL03',
	'TZ-AVL05',
	'TZ-AVL08',
	'TZ-AVL09',
	'TZ-AVL10',
	'TZ-AVL19',
	'TZ-AVL201',
	'TZ-AVL301',
	'TZ-GT01',
	'TZ-GT08',
	'TZ-GT09',
	'TZ-VN06',
	'U-Pro mini',
	'U101',
	'U101v1',
	'U101V1+',
	'UM02',
	'UM777',
	'UP102',
	'UT01',
	'UT03',
	'UT04',
	'UT05',
	'UT06',
	'uTrace03e',
	'UUx device',
	'V-MT001',
	'V208',
	'V520',
	'V580',
	'V680',
	'V690',
	'VALTRACK-V4',
	'Vias700',
	'Vjoycar G28',
	'VLT',
	'VNET',
	'VSUN3338',
	'VT 110 010',
	'VT 110 210',
	'VT 110 211',
	'VT 112 210',
	'VT 120 010',
	'VT 120 210',
	'VT100',
	'VT1000',
	'VT108',
	'VT1081',
	'VT1611',
	'VT200',
	'VT206',
	'VT300',
	'VT310',
	'VT310N',
	'VT400',
	'VT600',
	'VT600X',
	'VT800',
	'VT810',
	'VT87',
	'VT900',
	'VT900X',
	'VTFMS',
	'Webtech',
	'WeTrack 2',
	'Wialon IPS',
	'Wialon Retranslator',
	'Wikey Tracker 3.0',
	'WondeX SPT-10',
	'WondeX VT300',
	'WP-30C',
	'Wrist Band',
	'WT-110',
	'WTR1-T',
	'X01',
	'X02',
	'X03',
	'X04',
	'X05',
	'X06',
	'XE103',
	'XE109',
	'XE208',
	'XE209A',
	'XE209B',
	'XE209C',
	'XE210',
	'XE710',
	'XE800',
	'XG3700',
	'XG3780',
	'Xirgo XT2400 Series',
	'Xirgo XT6300 Series',
	'XRB 28',
	'XT-007',
	'XT-2000G',
	'XT-2050C',
	'XT-2060G',
	'XT-2150',
	'XT-2150C',
	'XT-2150G',
	'XT-2160G',
	'XT-3200',
	'XT-4500G',
	'XT-4550C',
	'XT-4560G',
	'XT-4700',
	'XT-4750C',
	'XT-4760',
	'XT-4850C',
	'XT-4860G',
	'XT-5000',
	'XT-5050C',
	'XT-5060',
	'XT-6200',
	'XT-6260',
	'XT009',
	'XT011',
	'XT013',
	'XT107',
	'XT7',
	'YG119',
	'ZhongXun Topin',
	'ZoomBox',
	'ZX612',
	'СН-5707',
];

const EquipmentStore = types
    .model('EquipmentStore', {
        types: types.optional(types.array(EquipmentModel), []),
    })
    .actions((self) => ({
        afterCreate() {
            const types = [];
            models.map((m) => {
                types.push({name: m});
            });
            self.setTypes(types);
        },
        setTypes(data) {
            self.types = data;
        },
    }));

export default EquipmentStore;

